<!-- Page 1 -->
<div class="pdf-page app-aul-030-24" id="aul03024">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>PROTECTIVE SAFEGUARDS </b>
  </p>
  <p class="font-large">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <p class="font-small mb-0">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small">COMMERCIAL PROPERTY COVERAGE PART</p>
  <br />
  <p class="font-small mb-0" style="text-align: center"><b>SCHEDULE</b></p>
  <table
    class="font-small"
    style="border: 1px solid black; border-collapse: collapse; width: 100%"
  >
    <tbody>
      <tr>
        <th
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          Premises Number
        </th>
        <th
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          Building Number
        </th>
        <th
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          Protective Safeguards Symbols Applicable
        </th>
      </tr>
      <tr>
        <td
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          All Covered Premises as described in the Declarations
        </td>
        <td
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          All Covered Buildings as described in the Declarations
        </td>
        <td
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          "P-9" All Protective Safeguards as described in Your submission and/or
          application
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <ol class="font-small" style="list-style-type: upper-alpha">
    <!-- A -->
    <li class="mb-3">
      <p>The following is added to the: Commercial Property Conditions</p>
      <p><b>PROTECTIVE SAFEGUARDS </b></p>
      <p>As a condition of this insurance, you are required to:</p>
      <ol>
        <li>
          Maintain the protective safeguards listed in the Schedule, and over
          which you have control, in complete working order;
        </li>
        <li>
          Actively engage and maintain in the "on" position at all times any
          automatic fire alarm or other automatic system listed in the Schedule;
          and
        </li>
        <li>
          Notify us if you know of any suspension of or impairment in any
          protective safeguard listed in the Schedule.
        </li>
        <p>
          However, if part of an Automatic Sprinkler System or Automatic
          Commercial Cooking Exhaust and Extinguishing System is shut off due to
          breakage, leakage, freezing conditions or opening of sprinkler heads,
          notification to us will not be necessary if you can restore full
          protection within 48 hours.
        </p>
      </ol>
    </li>
    <!-- B -->
    <li class="mb-3">
      The following is added to the EXCLUSIONS section of:<br />
      CAUSES OF LOSS - BASIC FORM <br />
      CAUSES OF LOSS - BROAD FORM <br />
      CAUSES OF LOSS - SPECIAL FORM
      <p>
        We will not pay for loss or damage caused by or resulting from fire if,
        prior to the fire, you failed to comply with any condition set forth in
        Paragraph <b>A</b>.
      </p>
    </li>
    <!-- C -->
    <li>
      The protective safeguards to which this endorsement applies are identified
      by the following symbols or as described in Your submission and/or
      application:
      <ul style="list-style-type: none">
        <li>
          <b>"P-1" Automatic Sprinkler System</b>, including related supervisory
          services.
          <ul style="list-style-type: none">
            <li>Automatic Sprinkler System means:</li>
            <ol style="list-style-type: lower-alpha">
              <li>
                Any automatic fire protective or extinguishing system, including
                connected:
                <ol>
                  <li>Sprinklers and discharge nozzles;</li>
                  <li>Ducts, pipes, valves and fittings;</li>
                  <li>Tanks, their component parts and supports; and</li>
                  <li>Pumps and private fire protection mains.</li>
                </ol>
              </li>
            </ol>
          </ul>
        </li>
      </ul>
    </li>
  </ol>
</div>

<!-- Page 2 -->
<div class="font-small pdf-page app-aul-030-24">
  <ul style="list-style-type: none">
    <li>
      <ul style="list-style-type: none">
        <li>
          <ul style="list-style-type: none">
            <li>
              <ol type="a" start="2">
                <li>
                  When supplied from an automatic fire protective system:
                  <ol>
                    <li>Non-automatic fire protective systems; and</li>
                    <li>Hydrants, standpipes and outlets.</li>
                  </ol>
                </li>
              </ol>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <ul style="list-style-type: none">
    <li>
      <ul style="list-style-type: none">
        <li>
          <b>"P-2" Automatic Fire Alarm</b>, protecting the entire building,
          that is:
          <ol style="list-style-type: lower-alpha">
            <li>Connected to a central station; or</li>
            <li>Reporting to a public or private fire alarm station.</li>
          </ol>
        </li>
        <li>
          <b>"P-3" Security Service</b>, with a recording system or watch clock,
          making hourly rounds covering the entire building, when the premises
          are not in actual operation.
        </li>
        <li>
          <b>"P-4" Service Contract</b> with a privately owned fire department
          providing fire protection service to the described premises.
        </li>
        <li>
          <b
            >“P-5” Automatic Commercial Cooking Exhaust And Extinguishing
            System</b
          >
          installed on cooking appliances and having the following components:
          <ol style="list-style-type: lower-alpha">
            <li>Hood;</li>
            <li>Grease removal device;</li>
            <li>Duct system; and</li>
            <li>Wet chemical fire extinguishing equipment.</li>
          </ol>
        </li>
        <li>
          <b>"P-9"</b> The protective system(s) described in the Schedule and/or
          Your submission and/or application
        </li>
      </ul>
    </li>
  </ul>
</div>
